// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"520":"97090c2f","757":"f5102e09","780":"a65ee605","973":"3bdacb9c","975":"e0caab49"}[chunkId] + ".chunk.css";
};